import ReactTooltip from "react-tooltip";
import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 37px;

  @media (max-width: 768px) {
    gap: 15px;
  }
`;

export const ContentDate = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #efefef;
  border-radius: 4px;
  position: relative;
  height: 65px;
  width: 65px;
  padding: 10px;

  @media (max-width: 768px) {
    width: 75px;
  }
`;

export const Month = styled.span`
  font-family: "Mangueira Bold";
  font-size: 16px;
  line-height: 25px;
  color: ${({ theme }) => theme.colors.blue};
  text-transform: capitalize;
`;

export const Year = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: #828282;
`;

interface IContentItem {
  showMobile?: boolean;
}

export const ContentItem = styled.div<IContentItem>`
  display: flex;
  flex-direction: column;
  min-width: 100px;

  @media (max-width: 768px) {
    min-width: auto;

    &:nth-of-type(3) {
      display: none;
    }
  }
`;

export const ItemTitle = styled.span`
  font-family: "Mangueira Bold";
  font-size: 12px;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.blue};
`;

export const ItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 16px;
  line-height: 24px;
  color: #828282;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

interface IBullet {
  status: string;
}

export const Bullet = styled.div<IBullet>`
  width: 7px;
  height: 7px;
  border-radius: 100%;
  background-color: ${({ status, theme }) => {
    switch (status) {
      case "PAGO":
        return theme.colors.lightGreen;
      case "VENCIDO":
        return "#e34e2a";
      case "A_VENCER":
        return "#f0b01b";
      default:
        return "000";
    }
  }};

  @media (max-width: 768px) {
    display: none;
  }
`;

export const BulletMobile = styled(Bullet)`
  display: none;

  @media (max-width: 768px) {
    display: block;
    position: absolute;
    top: 5px;
    left: 5px;
  }
`;

export const ContentActions = styled.div`
  display: flex;
  align-items: center;
  gap: 22px;

  svg {
    cursor: pointer;
    width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.colors.blue};
    outline: none;
  }
`;

interface TooltipPropsItem {
  size?: "normal" | "small";
}

interface ExtendedTooltipProps
  extends React.ComponentProps<typeof ReactTooltip>,
    TooltipPropsItem {}

export const TooltipAiOutlineInfoCircle = styled(
  ReactTooltip
)<ExtendedTooltipProps>`
  padding: 21px 28px !important;
  opacity: 1 !important;
  max-width: 450px;
  width: 100%;

  ${({ size }) =>
    size &&
    css`
      max-width: 228px;
      max-height: 58px;
    `}

  & span {
    font-size: 14px;
    font-family: "Mangueira Bold";
    line-height: 22px;
  }

  & p {
    margin: 0;
    font-size: 14px;
    line-height: 22px;
  }

  @media (max-width: 768px) {
    padding: 10px 14px !important;
    max-width: 200px;
  }
`;

export const ContainerItems = styled.div`
  display: flex;
  gap: 36px;

  @media (max-width: 768px) {
    gap: 15px;
    flex-wrap: wrap;
  }
`;

export const ActionSpinner = styled.div`
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const OptionsContainer = styled.div`
  position: relative;
`;

export const OptionsWrapper = styled.div`
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
  padding: 12px;
  border-radius: 9px;
  width: max-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const OptionItem = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    text-decoration: underline;
  }
`;

export const OptionLabel = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.blue};
  font-family: "Mangueira Bold";
`;

export const InfosWrapper = styled.div``;

export const InfoCondominium = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: unset;
  }
`;

export const InfoCondominiumWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const InfoContent = styled.span`
  display: inline-block;
  width: 400px;
  text-align: start;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: "Mangueira Bold";

  @media screen and (max-width: 768px) {
    width: 172px;
  }
`;
